import { Box, TextField, Typography, Button, InputBase } from '@mui/material';
import Container from 'common/components/Container';
import Image from 'next/image';
import { useState } from 'react';
import eventBus from 'containers/SaasModern/Mit/EventMit';
import SearchIcon from 'common/assets/image/logo/icon/SearchIcon';

const HeroSearch = () => {
  const handelChange = (e) => {
    eventBus.emit('customEvent', { itemSearch: e.target.value });
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{
        width: ['98%', '50%'],
        height: ['40px', '50px'],
        padding: '10px',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '10px',
        background: '#FFF',
        boxShadow: '0px 4px 40px 0px rgba(255, 110, 114, 0.24)',
      }}
    >
      <Box sx={{ width: '25px', height: '25px' }}>
        <SearchIcon />
      </Box>

      <InputBase
        sx={{
          flex: 1,
          border: '2px solid white',
          height: ['30px', null, '40px'],
        }}
        placeholder="Find an AI from the list"
        onChange={handelChange}
      />

      <Button
        sx={{
          display: 'flex',
          height: ['40px', null, '40px'],
          padding: '12px 16px',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '12px',
          border: '1px solid var(--Primary-Main, #FF6E72)',
          background: 'var(--Primary-Main, #FF6E72)',
          '&:hover': {
            background: 'var(--Primary-Dark, #D93A47)',
            borderColor: 'var(--Primary-Dark, #D93A47)',
          },
        }}
      >
        <Typography
          sx={{
            color: 'var(--White-White, #FFF)',
            fontSize: ['8px', null, '14px'],
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '140%',
            letterSpacing: '-0.28px',
          }}
        >
          {/* {slice.primary.inputplaceholder} */}search
        </Typography>
      </Button>
    </Box>
  );
};
export default HeroSearch;
